module.exports = __webpack_public_path__ + "media/rbshoa_720.502e0ce3.mp4";